import { apiResponseMiddleware } from "@/middleware/api-response";
import { api } from "@/api/axios-instance";
import { setToken } from "@/auth";

interface ChangeRoleResponse {
  accessToken: string;
  refreshToken: string;
}

export const changeActiveRole = async (roleId: number) => {
  return apiResponseMiddleware<ChangeRoleResponse>(
    api.post(
      `/api/Authentication/changeActiveRole/${roleId}`,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    ),
    (res) => {
      const { accessToken, refreshToken } = res.data;

      setToken({ accessToken, refreshToken });

      api.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${accessToken}`;
    },
    {
      showToast: false
    }
  );
};
